// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"73ab12d4","252":"342def80","499":"2c402509","573":"977a036b","829":"f60854ca"}[chunkId] + ".chunk.css";
};